/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function DocumentiCatalogoPage() {
  const [tab, setTab] = useState("catalogo");
  return (
    <div data-testid="documenti-catalogo-page">
      <div className="sw-page-title">
        <h1>📂 Catalogo Documenti Alunni</h1>
        <div className="sw-breadcrumb">Home &gt; Anagrafica &gt; Catalogo Documenti</div>
      </div>
      <div style={{ margin: "0 20px 12px", display: "flex", gap: 2, borderBottom: "2px solid #1565c0" }}>
        <TabBtn active={tab === "catalogo"} onClick={() => setTab("catalogo")} testid="docs-tab-catalogo">📁 Catalogo</TabBtn>
        <TabBtn active={tab === "log"} onClick={() => setTab("log")} testid="docs-tab-log">📜 Log caricamenti</TabBtn>
      </div>
      {tab === "catalogo" && <CatalogoTab />}
      {tab === "log" && <LogTab />}
    </div>
  );
}

function TabBtn({ active, onClick, children, testid }) {
  return (
    <button data-testid={testid} onClick={onClick}
      style={{ padding: "8px 18px", border: "none", background: active ? "#1565c0" : "white", color: active ? "white" : "#1565c0",
        fontWeight: 700, fontSize: 12, cursor: "pointer", borderRadius: "4px 4px 0 0", borderTop: "1px solid #ccc", borderLeft: "1px solid #ccc", borderRight: "1px solid #ccc" }}>
      {children}
    </button>
  );
}

function CatalogoTab() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [setup, setSetup] = useState({ visibile_in_portale_alunni: false });
  const [editing, setEditing] = useState(null); // null | {} (new) | item (edit)
  const [savingSetup, setSavingSetup] = useState(false);
  const [anni, setAnni] = useState([]);
  const [filterAnno, setFilterAnno] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filterAnno !== "") params.anno = filterAnno;
      const [r, s, a] = await Promise.all([
        api.get("/documenti-alunni/categorie", { params }),
        api.get("/documenti-alunni/setup"),
        api.get("/documenti-alunni/categorie/anni-disponibili"),
      ]);
      setItems(r.data.items || []);
      setSetup(s.data || { visibile_in_portale_alunni: false });
      setAnni(a.data.anni || []);
    } catch (e) {
      alert(e.response?.data?.detail || "Errore caricamento");
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, [filterAnno]);

  const saveSetup = async (val) => {
    setSavingSetup(true);
    try {
      await api.put("/documenti-alunni/setup", { visibile_in_portale_alunni: val });
      setSetup(s => ({ ...s, visibile_in_portale_alunni: val }));
    } catch (e) {
      alert(e.response?.data?.detail || "Errore salvataggio");
    } finally { setSavingSetup(false); }
  };

  const removeCat = async (it) => {
    if (!window.confirm(`Eliminare categoria "${it.descrizione}"?\nVerranno cancellati anche tutti i documenti caricati per questa categoria.`)) return;
    try {
      const r = await api.delete(`/documenti-alunni/categorie/${it.id}`);
      alert(`Categoria eliminata. ${r.data?.documenti_eliminati || 0} documenti rimossi.`);
      await load();
    } catch (e) {
      alert(e.response?.data?.detail || "Errore eliminazione");
    }
  };

  const toggleAttivo = async (it) => {
    try {
      await api.put(`/documenti-alunni/categorie/${it.id}`, { attivo: !it.attivo });
      await load();
    } catch (e) {
      alert(e.response?.data?.detail || "Errore");
    }
  };

  return (
    <div>

      {/* SETUP visibilità portale alunni */}
      <div style={{ background: "white", border: "1px solid #cfd8dc", borderRadius: 6, padding: 16, margin: "0 20px 14px" }}>
        <div style={{ fontSize: 13, fontWeight: 900, color: "#263238", marginBottom: 8 }}>⚙ Impostazioni globali</div>
        <label style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 13, fontWeight: 700, cursor: "pointer" }}>
          <input type="checkbox" checked={!!setup.visibile_in_portale_alunni}
            onChange={e => saveSetup(e.target.checked)} disabled={savingSetup}
            data-testid="docs-setup-visibile"
            style={{ width: 18, height: 18 }} />
          <span>Mostra "I miei documenti" nel portale alunno</span>
          {savingSetup && <span style={{ fontSize: 11, color: "#888" }}>(salvataggio…)</span>}
        </label>
        <div style={{ fontSize: 11, color: "#666", marginTop: 6, marginLeft: 28 }}>
          Se attivata, ogni alunno vedrà nel proprio portale una card "I miei documenti" dove può visualizzare e caricare i propri documenti per le categorie attive.
        </div>
      </div>

      {/* TOOLBAR */}
      <div style={{ display: "flex", gap: 10, padding: "0 20px 12px", alignItems: "center", flexWrap: "wrap" }}>
        <button onClick={() => setEditing({})} data-testid="docs-cat-new"
          style={{ padding: "8px 16px", background: "#2e7d32", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer", borderRadius: 3 }}>
          ➕ Nuova categoria
        </button>
        <button onClick={load} data-testid="docs-cat-reload"
          style={{ padding: "8px 14px", background: "#455a64", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: "pointer", borderRadius: 3 }}>
          🔄 Aggiorna
        </button>
        <label style={{ fontSize: 11, fontWeight: 700, color: "#555", display: "flex", alignItems: "center", gap: 6 }}>
          Filtra anno:
          <select value={filterAnno} onChange={e => setFilterAnno(e.target.value)}
            data-testid="docs-cat-filter-anno"
            style={{ padding: "6px 10px", border: "1px solid #cfd8dc", fontSize: 12, borderRadius: 3 }}>
            <option value="">— Tutti —</option>
            {anni.map(a => <option key={a} value={a}>{a}/{(a + 1).toString().slice(2)}</option>)}
          </select>
        </label>
        <span style={{ color: "#666", fontSize: 12 }}>{items.length} categori{items.length === 1 ? "a" : "e"}</span>
      </div>

      {loading ? <div style={{ padding: 30, textAlign: "center", color: "#666" }}>Caricamento…</div> : (
        <div style={{ padding: "0 20px" }}>
        <table className="sw-data-table" style={{ width: "100%", background: "white" }}>
          <thead>
            <tr style={{ background: "#37474f", color: "white" }}>
              <th style={{ padding: 8, textAlign: "center", width: 70 }}>Anno</th>
              <th style={{ padding: 8, textAlign: "center", width: 60 }}>Ordine</th>
              <th style={{ padding: 8, textAlign: "left", width: 160 }}>Codice</th>
              <th style={{ padding: 8, textAlign: "left" }}>Descrizione</th>
              <th style={{ padding: 8, textAlign: "center", width: 100 }}>Attivo</th>
              <th style={{ padding: 8, textAlign: "center", width: 160 }}>Azioni</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && (
              <tr><td colSpan={6} style={{ padding: 30, textAlign: "center", color: "#999" }}>Nessuna categoria. Clicca "➕ Nuova categoria" per iniziare.</td></tr>
            )}
            {items.map(it => (
              <tr key={it.id} data-testid={`docs-cat-row-${it.id}`}>
                <td style={{ padding: 8, textAlign: "center", fontWeight: 700, color: it.anno ? "#1565c0" : "#bbb", fontFamily: "monospace" }}>
                  {it.anno ? `${it.anno}/${(it.anno + 1).toString().slice(2)}` : "—"}
                </td>
                <td style={{ padding: 8, textAlign: "center", color: "#666" }}>{it.ordine}</td>
                <td style={{ padding: 8, fontFamily: "monospace", fontSize: 11, color: "#1565c0" }}>{it.codice}</td>
                <td style={{ padding: 8, fontWeight: 600 }}>{it.descrizione}</td>
                <td style={{ padding: 8, textAlign: "center" }}>
                  <button onClick={() => toggleAttivo(it)}
                    style={{ padding: "3px 10px", background: it.attivo ? "#4caf50" : "#bdbdbd", color: "white", border: "none", fontSize: 10, fontWeight: 700, cursor: "pointer", borderRadius: 10 }}>
                    {it.attivo ? "✓ Attivo" : "✕ Inattivo"}
                  </button>
                </td>
                <td style={{ padding: 8, textAlign: "center", whiteSpace: "nowrap" }}>
                  <button onClick={() => setEditing(it)} data-testid={`docs-cat-edit-${it.id}`}
                    style={{ padding: "4px 10px", background: "#1565c0", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: "pointer", borderRadius: 2, marginRight: 4 }}>
                    ✎ Modifica
                  </button>
                  <button onClick={() => removeCat(it)} data-testid={`docs-cat-del-${it.id}`}
                    style={{ padding: "4px 10px", background: "#b71c1c", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: "pointer", borderRadius: 2 }}>
                    🗑
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      )}

      {editing && <CategoriaEditModal item={editing} close={() => setEditing(null)} onSaved={load} />}
    </div>
  );
}

function CategoriaEditModal({ item, close, onSaved }) {
  const isNew = !item.id;
  const [codice, setCodice] = useState(item.codice || "");
  const [descrizione, setDescrizione] = useState(item.descrizione || "");
  const [ordine, setOrdine] = useState(item.ordine ?? 0);
  const [anno, setAnno] = useState(item.anno ?? "");
  const [attivo, setAttivo] = useState(item.attivo !== false);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!descrizione.trim()) { alert("Descrizione obbligatoria"); return; }
    setSaving(true);
    try {
      const payload = {
        codice: codice.trim() || descrizione.toUpperCase().replace(/\s+/g, "_"),
        descrizione: descrizione.trim(),
        ordine: parseInt(ordine, 10) || 0,
        anno: anno === "" ? null : parseInt(anno, 10),
        attivo,
      };
      if (isNew) {
        await api.post("/documenti-alunni/categorie", payload);
      } else {
        await api.put(`/documenti-alunni/categorie/${item.id}`, payload);
      }
      close();
      onSaved();
    } catch (e) {
      alert(e.response?.data?.detail || "Errore");
    } finally { setSaving(false); }
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
      <div style={{ background: "white", borderRadius: 6, width: 500, maxWidth: "92vw" }}>
        <div style={{ padding: "12px 16px", background: "#1565c0", color: "white", display: "flex", justifyContent: "space-between" }}>
          <div style={{ fontWeight: 700, fontSize: 14 }}>{isNew ? "➕ Nuova categoria" : "✎ Modifica categoria"}</div>
          <button onClick={close} style={{ background: "transparent", border: "none", color: "white", fontSize: 22, cursor: "pointer" }}>×</button>
        </div>
        <div style={{ padding: 18 }}>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#555", display: "block", marginBottom: 4 }}>Descrizione *</label>
            <input value={descrizione} onChange={e => setDescrizione(e.target.value)} autoFocus
              data-testid="docs-cat-modal-desc"
              style={{ width: "100%", padding: 8, border: "1px solid #cfd8dc", fontSize: 13, borderRadius: 3 }} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#555", display: "block", marginBottom: 4 }}>Codice (univoco, opzionale)</label>
            <input value={codice} onChange={e => setCodice(e.target.value.toUpperCase())}
              data-testid="docs-cat-modal-codice"
              placeholder={(descrizione || "").toUpperCase().replace(/\s+/g, "_") || "ES_DOCUMENTO"}
              style={{ width: "100%", padding: 8, border: "1px solid #cfd8dc", fontSize: 12, fontFamily: "monospace", borderRadius: 3 }} />
          </div>
          <div style={{ display: "flex", gap: 12, marginBottom: 14 }}>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: "#555", display: "block", marginBottom: 4 }}>Ordine</label>
              <input type="number" value={ordine} onChange={e => setOrdine(e.target.value)}
                data-testid="docs-cat-modal-ordine"
                style={{ width: "100%", padding: 8, border: "1px solid #cfd8dc", fontSize: 13, borderRadius: 3 }} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: "#555", display: "block", marginBottom: 4 }}>Anno scolastico</label>
              <input type="number" value={anno} onChange={e => setAnno(e.target.value)}
                data-testid="docs-cat-modal-anno"
                placeholder="es. 2025"
                style={{ width: "100%", padding: 8, border: "1px solid #cfd8dc", fontSize: 13, borderRadius: 3 }} />
            </div>
            <label style={{ fontSize: 12, display: "flex", alignItems: "center", gap: 6, alignSelf: "flex-end", cursor: "pointer", paddingBottom: 8 }}>
              <input type="checkbox" checked={attivo} onChange={e => setAttivo(e.target.checked)} />
              <span>Attiva</span>
            </label>
          </div>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <button onClick={close} disabled={saving} style={{ padding: "8px 18px", background: "white", color: "#555", border: "1px solid #ccc", fontSize: 12, fontWeight: 700, cursor: "pointer", borderRadius: 3 }}>
              Annulla
            </button>
            <button onClick={save} disabled={saving} data-testid="docs-cat-modal-save"
              style={{ padding: "8px 18px", background: "#2e7d32", color: "white", border: "none", fontSize: 12, fontWeight: 800, cursor: saving ? "wait" : "pointer", borderRadius: 3 }}>
              {saving ? "Salvataggio…" : "💾 Salva"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}



const ACTION_BADGE = {
  upload: { bg: "#e8f5e9", color: "#1b5e20", border: "#4caf50", label: "⬆ Upload" },
  delete: { bg: "#ffebee", color: "#b71c1c", border: "#ef5350", label: "🗑 Delete" },
  view: { bg: "#e3f2fd", color: "#0d47a1", border: "#1565c0", label: "👁 View" },
  download: { bg: "#f3e5f5", color: "#4a148c", border: "#6a1b9a", label: "⤓ Download" },
};

function LogTab() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterAction, setFilterAction] = useState("");
  const [filterCod, setFilterCod] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const params = { limit: 500 };
      if (filterAction) params.action = filterAction;
      if (filterCod) params.alunno_cod = filterCod;
      const r = await api.get("/documenti-alunni/log", { params });
      setItems(r.data.items || []);
    } catch (e) {
      alert(e.response?.data?.detail || "Errore caricamento log");
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filterAction]);

  const fmtTs = (iso) => {
    if (!iso) return "—";
    try {
      return new Date(iso).toLocaleString("it-IT", {
        day: "2-digit", month: "2-digit", year: "numeric",
        hour: "2-digit", minute: "2-digit", second: "2-digit",
      });
    } catch { return iso; }
  };

  return (
    <div>
      <div style={{ display: "flex", gap: 10, padding: "0 20px 12px", alignItems: "center", flexWrap: "wrap" }}>
        <select value={filterAction} onChange={e => setFilterAction(e.target.value)}
          data-testid="docs-log-filter-action"
          style={{ padding: "6px 10px", border: "1px solid #cfd8dc", fontSize: 12, borderRadius: 3 }}>
          <option value="">Tutte le azioni</option>
          <option value="upload">⬆ Upload</option>
          <option value="delete">🗑 Delete</option>
          <option value="view">👁 View</option>
          <option value="download">⤓ Download</option>
        </select>
        <input value={filterCod} onChange={e => setFilterCod(e.target.value)} onKeyDown={e => e.key === "Enter" && load()}
          data-testid="docs-log-filter-cod"
          placeholder="Cod. alunno (Invio per cercare)"
          style={{ padding: "6px 10px", border: "1px solid #cfd8dc", fontSize: 12, borderRadius: 3, width: 200 }} />
        <button onClick={load} data-testid="docs-log-reload"
          style={{ padding: "6px 14px", background: "#455a64", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: "pointer", borderRadius: 3 }}>
          🔄 Aggiorna
        </button>
        <span style={{ color: "#666", fontSize: 12 }}>{items.length} entr{items.length === 1 ? "y" : "ies"}</span>
      </div>

      {loading ? <div style={{ padding: 30, textAlign: "center", color: "#666" }}>Caricamento…</div> : (
        <div style={{ padding: "0 20px", overflowX: "auto" }}>
          <table className="sw-data-table" style={{ width: "100%", background: "white", minWidth: 1000, fontSize: 11 }}>
            <thead>
              <tr style={{ background: "#37474f", color: "white" }}>
                <th style={{ padding: 8, textAlign: "left", width: 140 }}>Data/Ora</th>
                <th style={{ padding: 8, textAlign: "center", width: 120 }}>Azione</th>
                <th style={{ padding: 8, textAlign: "left" }}>Alunno</th>
                <th style={{ padding: 8, textAlign: "left" }}>Categoria</th>
                <th style={{ padding: 8, textAlign: "left" }}>Filename</th>
                <th style={{ padding: 8, textAlign: "center", width: 90 }}>Size</th>
                <th style={{ padding: 8, textAlign: "left", width: 200 }}>Utente</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 && (
                <tr><td colSpan={7} style={{ padding: 30, textAlign: "center", color: "#999" }}>Nessuna registrazione nel log</td></tr>
              )}
              {items.map(r => {
                const b = ACTION_BADGE[r.action] || { bg: "#eceff1", color: "#37474f", border: "#90a4ae", label: r.action };
                return (
                  <tr key={r.id} data-testid={`docs-log-row-${r.id}`}>
                    <td style={{ padding: 6, fontFamily: "monospace", fontSize: 10, color: "#37474f" }}>{fmtTs(r.timestamp)}</td>
                    <td style={{ padding: 6, textAlign: "center" }}>
                      <span style={{ padding: "2px 8px", background: b.bg, border: `1px solid ${b.border}`, color: b.color, borderRadius: 10, fontSize: 10, fontWeight: 800 }}>
                        {b.label}
                      </span>
                    </td>
                    <td style={{ padding: 6 }}>
                      <b>{r.alunno_cognome} {r.alunno_nome}</b>
                      <div style={{ fontSize: 9, color: "#888", fontFamily: "monospace" }}>cod. {r.alunno_cod} · {r.classe || "?"} · {r.settore || "?"}</div>
                    </td>
                    <td style={{ padding: 6 }}>
                      <div style={{ fontWeight: 600 }}>{r.categoria_descrizione || "—"}</div>
                      <div style={{ fontSize: 9, color: "#888", fontFamily: "monospace" }}>{r.categoria_codice || ""}</div>
                    </td>
                    <td style={{ padding: 6, fontSize: 10, color: "#1565c0" }}>
                      {r.filename || "—"}
                      {r.replaced && <span style={{ marginLeft: 6, color: "#ef6c00", fontWeight: 700 }}>(sostituito)</span>}
                    </td>
                    <td style={{ padding: 6, textAlign: "center", fontSize: 10, color: "#555" }}>
                      {r.size != null ? (r.size < 1024 ? `${r.size} B` : r.size < 1024 * 1024 ? `${(r.size / 1024).toFixed(1)} KB` : `${(r.size / (1024 * 1024)).toFixed(2)} MB`) : "—"}
                    </td>
                    <td style={{ padding: 6 }}>
                      <div style={{ fontWeight: 600, color: "#37474f" }}>{r.user}</div>
                      <div style={{ fontSize: 9, color: "#888" }}>{r.user_role}</div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
